<template>
    <div class="header">
        <div style="display:flex;align-items:baseline;">
            <img alt="" src="@/assets/images/kinglonglogo.png" style="width:181px;height:50px;">
            <div style="font-size: 15pt !important;flex: 1;text-align: right;  font-weight: bold !important;">
                {{companyName}}
            </div>
        </div>
        <el-divider></el-divider>
        <div class="report-header">
            <h1>车辆运行分析报告</h1>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        companyName: {
            type: String,
            default: '金龙班车'
        }
        
    }
}
</script>
<style scoped>
/* 报告标题样式 */
.report-header {
    text-align: center;
    
}

.report-header h1 {
    color: #333;
    font-size: 28px;
}
</style>